import { BaseEntity } from '@ianesthesie-kit/services';

export enum SourceType {
  DOCTOR_INPUT = 'DOCTOR_INPUT',
  PATIENT_INPUT = 'PATIENT_INPUT',
  PREDEFINED = 'PREDEFINED',
  GENERATED = 'GENERATED',
  AI_SUGGESTION = 'AI_SUGGESTION',
  AI_OVERRIDE = 'AI_OVERRIDE',
  OCR = 'OCR',
  EPIC = 'EPIC',
  PATIENTS_APP = 'PATIENTS_APP',
  NLP_SUGGESTION = 'NLP_SUGGESTION',
  AUTOMATION = 'AUTOMATION'
}

export type UserInputSourceType =
  | SourceType.PATIENT_INPUT
  | SourceType.DOCTOR_INPUT;

export type AiSourceType = SourceType.AI_SUGGESTION | SourceType.AI_OVERRIDE;

export interface MedicalComponent extends BaseEntity {
  sourceType?: SourceType;
}

export const isMedicalComponent = (obj: any): obj is MedicalComponent =>
  !!obj && typeof obj === 'object' && 'sourceType' in obj;

export const isUserInput = (
  sourceType?: SourceType
): sourceType is UserInputSourceType =>
  sourceType === SourceType.DOCTOR_INPUT ||
  sourceType === SourceType.PATIENT_INPUT;

export const isAiInput = (
  sourceType?: SourceType
): sourceType is AiSourceType =>
  sourceType === SourceType.AI_SUGGESTION ||
  sourceType === SourceType.AI_OVERRIDE;

export const isSourceTypeTranslatable = (sourceType?: SourceType) =>
  !isUserInput(sourceType) &&
  sourceType !== SourceType.EPIC &&
  sourceType !== SourceType.PATIENTS_APP &&
  sourceType !== SourceType.NLP_SUGGESTION;
